/**
 * Date <-> "YYYY-MM-DD" helpers for the shared DateTimePicker (tag matter-economics).
 * Parsing/formatting is done in LOCAL time so the picker doesn't shift a day across
 * timezones (which `new Date("YYYY-MM-DD")` / `toISOString()` would).
 */

export const ymdToDate = (s?: string | null): Date | null =>
  s ? new Date(`${s}T00:00:00`) : null;

export const dateToYmd = (d: Date | null): string => {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
